<template>
  <div class="mobile-modal-list">
    <div
        v-for="option in list"
        class="mobile-modal-list-item"
        :class="{ 'mobile-modal-list-item--selected': (selectedOpt as any)?.code === (option as any).code }"
        :key="(option as any).code"
        @click="selectOption(option)">
      <div class="mobile-modal-list-item__content">
        <span v-if="(option as any).flag" class="mobile-modal-list-item__flag" :class="(option as any).flag"></span>
        <span class="mobile-modal-list-item__code">
          <template v-if="(option as any).symbol">{{ (option as any).symbol }}&nbsp;</template>{{(option as any).code.toUpperCase()}}
        </span>
        <span v-if="(option as any).name" class="mobile-modal-list-item__name">{{ (option as any).name }}</span>
      </div>
      <div v-if="(selectedOpt as any)?.code === (option as any).code" class="mobile-modal-list-item__check">
        <span class="icon icon-check-5"></span>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
const {
  list,
  selectedOption
} = defineProps({
  list: {type: Array},
  selectedOption: {type: Object}
})

const selectedOpt = computed(() => selectedOption || list?.[0])
const emit = defineEmits(['change'])

const selectOption = (option: any) => {
  emit('change', option)
}
</script>

<style scoped lang="scss">
.mobile-modal-list {
  padding: 8px 0;

  .mobile-modal-list-item {
    padding: 12px 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    cursor: pointer;
    white-space: nowrap;
    transition: background-color 0.15s ease;

    &:hover {
      background: var(--light-grey);
    }

    &--selected {
      background: var(--blue-highlight);

      .mobile-modal-list-item__code {
        color: var(--blue);
      }
    }

    &__content {
      display: flex;
      align-items: center;
      gap: 12px;
      min-width: 0;
    }

    &__flag {
      font-size: 18px;
      width: 24px;
      border-radius: 2px;
      flex-shrink: 0;
    }

    &__code {
      font-size: 14px;
      font-weight: 600;
      color: var(--black);
      flex-shrink: 0;
    }

    &__name {
      font-size: 13px;
      font-weight: 400;
      color: var(--dark-grey);
      overflow: hidden;
      text-overflow: ellipsis;
    }

    &__check {
      margin-left: 12px;
      flex-shrink: 0;

      .icon {
        display: flex;
        align-items: center;
        justify-content: center;
        color: var(--blue);
        font-size: 16px;
      }
    }
  }
}
</style>
